/* eslint-disable quote-props */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable func-names */
import EDC from './globals';

/**
 *
 */
EDC.CursorManager = function (canvas) {
  this.gameCanvas = canvas;
  this.map = [];
};
/**
 *
 */
EDC.CursorManager.prototype.setCursorEvents = function (target, options) {
  for (const eventName in options) {
    const cursorValue = options[eventName];
    target.on(eventName, this.setCursor.bind(this, cursorValue));
  }
};
/**
 *
 */
EDC.CursorManager.prototype.setCursor = function (value) {
  this.gameCanvas.style.cursor = value;
};
/**
 *
 */
EDC.CursorManager.prototype.resetCursor = function () {
  this.setCursor('default');
};
/**
 *
 */
EDC.CursorManager.prototype.setDefaultDraggableEvents = function (target) {
  this.setCursorEvents(target, {
    'pointerover': 'url(../phaser-assets/cursors/cursor_mouseover_64.png), pointer',
    'pointerout': 'default',
    'dragstart': 'url(../phaser-assets/cursors/cursor_mousedown_64.png), pointer',
    'dragend': 'url(../phaser-assets/cursors/cursor_mouseover_64.png), pointer',
  });
};

export default EDC.CursorManager;
